import { type UUID } from '@/backend/schema/uuid'
import type { InstructionFeedbackGeneratedPayload } from './useInstructionsChannelSubscriber'

// Note: the backend currently does not support the endpoint and web socket
// events that we need for the AI review feedback, so we're relying on a
// mock data for now. This will be removed once the backend supports the
// necessary events and endpoints.

export const mockWebSocketAiReviewFeedbackMessage = (
  instructionId: UUID,
  instructionVersionId: UUID,
): InstructionFeedbackGeneratedPayload => ({
  instruction_id: instructionId,
  instruction_version_id: instructionVersionId,
  feedback: {
    summary:
      'To ensure your rule triggers accurate and reliable callouts, follow these core principles.',
    items: [
      {
        criteria_met: true,
        criteria_text: 'Be specific about the properties and their values',
        comment: null,
      },
      {
        criteria_met: false,
        criteria_text: 'Avoid ambiguous or overlapping conditions',
        comment:
          'If an annotation has property "row_position" - This condition is unclear. Please specify what exact values are expected, and consider rephrasing for better readability.',
      },
      {
        criteria_met: true,
        criteria_text: 'Make sure your rule is clear and easy to understand',
        comment: null,
      },
      {
        criteria_met: true,
        criteria_text: 'Use consistent terminology across your dataset',
        comment: null,
      },
    ],
  },
})
